import { shouldAddItem } from "../shouldAddItem.js";
import { fileItemUngzip } from "./fileItemUngzip.js";
import { fileItemUnzip } from "./fileItemUnzip.js";
/**
 * Utility function that allows to expand gzip and zip files without really expanding them
 * @param fileCollection
 * @param originalFileItem
 * @param options
 * @returns
 */
export async function expandAndFilter(originalFileItem, options = {}) {
    const { filter = {} } = options;
    if (!shouldAddItem(originalFileItem.relativePath, filter)) {
        return [];
    }
    const fileItem = await fileItemUngzip(originalFileItem, options);
    const fileItems = await fileItemUnzip(fileItem, options);
    for (const fileItem of fileItems) {
        fileItem.sourceUUID = originalFileItem.sourceUUID;
    }
    return fileItems;
}
//# sourceMappingURL=expandAndFilter.js.map